/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S11_Li3_DescInputs */

const tr_iade_iptal_s11_li3_desc = /** @type {(inputs: Iade_Iptal_S11_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceden kabul edilen sözleşme 30 gün boyunca JSON, CSV ve PDF olarak dışa aktarma hakkı tanıyorsa bu hak geçerliliğini korur; talebinizi kvkk@emonse.com adresine iletebilirsiniz.`)
};

const en_iade_iptal_s11_li3_desc = /** @type {(inputs: Iade_Iptal_S11_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If your previously accepted contract grants 30 days of export in JSON, CSV and PDF, that right remains valid; send your request to kvkk@emonse.com.`)
};

const de_iade_iptal_s11_li3_desc = /** @type {(inputs: Iade_Iptal_S11_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewährt Ihre bereits angenommene Vertragsfassung 30 Tage Export in JSON, CSV und PDF, bleibt dieser Anspruch bestehen; richten Sie die Anfrage an kvkk@emonse.com.`)
};

const ru_iade_iptal_s11_li3_desc = /** @type {(inputs: Iade_Iptal_S11_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если ранее принятый договор предоставляет 30 дней для экспорта в JSON, CSV и PDF, это право сохраняется; направьте запрос на kvkk@emonse.com.`)
};

/**
* | output |
* | --- |
* | "If your previously accepted contract grants 30 days of export in JSON, CSV and PDF, that right remains valid; send your request to kvkk@emonse.com." |
*
* @param {Iade_Iptal_S11_Li3_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s11_li3_desc = /** @type {((inputs?: Iade_Iptal_S11_Li3_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S11_Li3_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s11_li3_desc(inputs)
	if (locale === "de") return de_iade_iptal_s11_li3_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s11_li3_desc(inputs)
	return tr_iade_iptal_s11_li3_desc(inputs)
});